module.exports = __webpack_public_path__ + "static/media/achtergrond.ead0ee9d.svg";